import { APP_STRINGS } from '../../../res';

export const formatPermissionError = (message: string) =>
    `${APP_STRINGS.forms.permissions.messages.permissionError}: ${message}`;
